/**
 * General views
 * Path: `@/views`
 */

import multiguard from "vue-router-multiguard"
import { requireAuth } from "@/utils/middleware"

const Help = () => import("@/views/Help.vue")
// const General = () => import("@/views/project/General.vue")
const Home = () => import("@/views/Home.vue")
const NotificationsPage = () => import("@/views/NotificationsPage.vue")
const ProjectDrawer = () => import("@/components/layouts/core/ProjectDrawer.vue")

export default [
  {
    path: "/home",
    name: "Home",
    component: Home,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  }
]
